import { render } from "./ProfileCard.vue?vue&type=template&id=a04a1e32&scoped=true&ts=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"

import "./ProfileCard.vue?vue&type=style&index=0&id=a04a1e32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04a1e32"]])

export default __exports__